// @ts-ignore
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/20/solid";

import { Button, PageButton } from "../StyledTable/Utils";

interface PaginationProps {
  previousPage: () => void;
  handleNextPage: () => void;
  handlePreviousPage: () => void;
  nextPage: () => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
  pageOptions: any;
  pageIndex: any;
  gotoPage: (arg0: number) => void;
  pageCount: number;
  pageSize: number;
  setPageSize: (arg0: number) => void;
  currentPage: number;
  serverPaginated: boolean;
  noOfPages: number;
  goToFirstPage: () => void;
  goToLastPage: () => void;
  handlePageSize: (arg0: number) => void;
}

const StyledPagination = ({
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageOptions,
  gotoPage,
  pageCount,
  pageSize,
  setPageSize,
  handleNextPage,
  handlePreviousPage,
  currentPage,
  serverPaginated,
  noOfPages,
  goToFirstPage,
  goToLastPage,
  handlePageSize,
}: PaginationProps) => {
  function gotToPreviousPage() {
    previousPage();
  }
  function gotToNextPage() {
    nextPage();
  }

  return (
    <div className="flex items-center justify-between py-3">
      <div className="flex flex-1 justify-between sm:hidden">
        <Button onClick={gotToPreviousPage} disabled={!canPreviousPage}>
          Previous
        </Button>
        <Button onClick={gotToNextPage} disabled={!canNextPage}>
          Next
        </Button>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        {pageCount > 0 && (
          <div className="flex gap-x-2">
            <span className="text-sm text-gray-700">
              Page{" "}
              <span className="font-medium">
                {(serverPaginated ? currentPage : pageIndex) + 1}
              </span>
              {serverPaginated && (
                <span className="font-medium">of {noOfPages}</span>
              )}
              {!serverPaginated && (
                <span className="font-medium"> of {pageOptions.length}</span>
              )}
            </span>
            <select
              value={pageSize}
              onChange={
                serverPaginated
                  ? (e: any) => {
                      setPageSize(Number(e.target.value));
                      handlePageSize(Number(e.target.value));
                    }
                  : (e: any) => setPageSize(Number(e.target.value))
              }
            >
              {[10, 20, 30].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </div>
        )}
        {pageCount > 0 && (
          <div>
            <nav
              className="inline-flex -space-x-px rounded-md shadow-sm"
              aria-label="Pagination"
            >
              <PageButton
                className="rounded-l-md"
                onClick={serverPaginated ? goToFirstPage : () => gotoPage(0)}
                // disabled={!canPreviousPage}
              >
                <span className="sr-only">First</span>
                <ChevronDoubleLeftIcon className="h-5 w-5" aria-hidden="true" />
              </PageButton>
              <PageButton
                onClick={serverPaginated ? handlePreviousPage : previousPage}
                // disabled={!canPreviousPage}
              >
                <span className="sr-only">Previous</span>
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
              </PageButton>
              <PageButton onClick={serverPaginated ? handleNextPage : nextPage}>
                <span className="sr-only">Next</span>
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
              </PageButton>
              <PageButton
                className="rounded-r-md"
                onClick={
                  serverPaginated ? goToLastPage : () => gotoPage(pageCount - 1)
                }
                // disabled={!canNextPage}
              >
                <span className="sr-only">Last</span>
                <ChevronDoubleRightIcon
                  className="h-5 w-5"
                  aria-hidden="true"
                />
              </PageButton>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
};

export default StyledPagination;
